import IconButtonsTypes from '~/constants/types/IconButtonsTypes';

export function initialState() {
  return {
    intersectingIcons: {
      /* [iconId]: true/false */
    }
  };
}

export default function iconButtons(state = initialState(), action) {
  switch (action.type) {
    case IconButtonsTypes.ACTIVATE_INTERSECTING_ICON: {
      const updatedIds = getObjectWithKeysFromArrayOfStrings({
        arrayStr: action.payload,
        isActive: true
      });

      return {
        ...state,
        intersectingIcons: {
          ...state.intersectingIcons,
          ...updatedIds
        }
      };
    }
    case IconButtonsTypes.DEACTIVATE_INTERSECTING_ICON: {
      const updatedIds = getObjectWithKeysFromArrayOfStrings({
        arrayStr: action.payload,
        isActive: false
      });

      return {
        ...state,
        intersectingIcons: {
          ...state.intersectingIcons,
          ...updatedIds
        }
      };
    }
    default:
      return state;
  }
}

function getObjectWithKeysFromArrayOfStrings({arrayStr, isActive}) {
  if (!arrayStr) {
    return null;
  }

  if (!Array.isArray(arrayStr)) {
    return null;
  }

  const dictWithKeys = {};

  arrayStr.forEach(id => {
    dictWithKeys[id] = isActive;
  });

  return dictWithKeys;
}
